export function handleFetchErrors(response: Response): Promise<any> {
    if (!response.ok) {
        return Promise.reject(response)
    }

    return Promise.resolve(response)
}
